import { useText } from "./text";

export function formatAddress(location) {
    if(location) {
    const addressFormatted =
        (location.address.addressLine1 != null ? (location.address.addressLine1 + "<br />") : "") +
        (location.address.addressLine2 != null ? (location.address.addressLine2 + "<br />") : "") +
        (location.address.city != null ? location.address.city : "") +
        ((location.address.city != null ? ", " : "") + (location.address.state != null ? location.address.state : "")) +
        ((location.address.state != null ? " " : "") + (location.address.zip != null ? location.address.zip : ""));
    return addressFormatted;
    } else {
        return "";
    }
}

export function formatDirectionsLink(location, loc) {
    if (location.address.addressLine2 != null) {
        return `https://www.google.com/maps/dir/?api=1&origin=${loc.lat},${loc.lng}&destination=${location.address.addressLine1},${location.address.addressLine2},${location.address.city},${location.address.state},${location.address.zip}&travelmode=driving`;
    }
    else {
        return `https://www.google.com/maps/dir/?api=1&origin=${loc.lat},${loc.lng}&destination=${location.address.addressLine1},${location.address.city},${location.address.state},${location.address.zip}&travelmode=driving`;
    }
}

export function formatServicesString(location) {
    let services = [];
    if (location.atm) {
        services.push(useText("atm"));
    }
    if (location.quickDeposit) {
        services.push(useText("quickDeposit"));
    }
    if (location.driveThru) {
        services.push(useText("driveThru"));
    }
    if (location.fullService) {
        services.push(useText("fullService"));
    }
    if (location.instantIssueDebitCard) {
        services.push(useText("instantIssueDebitCard"));
    }

    if (location.safeDepositBoxes) {
        services.push(useText("safeDepositBoxes"))
    }

    return services.join(", ");
}

export function formatTelephone(location) {
    const telephoneFormatted = 
        location.phone != null ? location.phone.replace(new RegExp("[^0-9]", 'g'), '') : '';

    return "tel:" + telephoneFormatted;
}

export function hasServices(location) {
  return location.fullService || location.atm || location.driveThru || location.instantIssueDebitCard || location.quickDeposit || location.safeDepositBoxes;
}
